import {api} from '@/api/factory';

class Video {
    constructor() {}

    getKinopoiskId(kpId:number | string, title_original:string, signal?: AbortSignal) {
        return api({
            url: `/v1/content-manager/import/metadata`,
            method: 'GET',
            params: {
                kp_id: kpId,
                title_original: title_original
            },
            signal: signal
        })
    }

    getByImdId(imdbId:number | string, title_original:string, signal?: AbortSignal) {
        return api({
            url: `/v1/content-manager/import/metadata`,
            method: 'GET',
            params: {
                imdb_id: imdbId,
                title_original: title_original
            },
            signal: signal
        })
    }
}

export default Video